import React from "react";
import { Helmet } from "react-helmet-async";
import Nav from "../components/app/Nav";
import Footer from "../components/app/Footer";
import FloatingButton from "../components/app/FloatingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faBullseye,
  faEye,
  faHandshake,
  faLightbulb,
  faShieldAlt,
  faBolt,
  faUserCheck,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../styles/app/CompanyPage.module.css";

const CompanyPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Quiénes Somos - elPaket | Envíos a Latinoamérica</title>
        <meta
          name="description"
          content="Conoce más sobre elPaket. Somos una plataforma digital que conecta y coordina toda la cadena logística para envíos desde Estados Unidos hacia Latinoamérica."
        />
        <meta
          name="keywords"
          content="quienes somos elpaket, mision elpaket, vision elpaket, valores, envios latinoamerica, courier"
        />
        <link rel="canonical" href="https://elpaket.com/company" />
      </Helmet>

      <Nav />
      {/*
      <FloatingButton />
      */}

      <div className={styles.companyPage}>
        {/* ── Hero ── */}
        <div className={styles.companyHero}>
          <div className={styles.companyHeroContent}>
            <div className={styles.companyHeroLeft}>
              <p className={styles.headerBrand}>elPaket</p>
              <h1 className={styles.companyHeroTitle}>Quiénes Somos</h1>
              <p className={styles.companySubtitleHero}>
                Conectando personas, familias y empresas entre Estados Unidos y
                Latinoamérica.
              </p>
            </div>
            <div className={styles.companyHeroRight}>
              <FontAwesomeIcon
                icon={faBuilding}
                className={styles.companyHeroIcon}
              />
            </div>
          </div>
        </div>

        {/* ── Body ── */}
        <div className={styles.companyBody}>
          <div className={styles.companyContainer}>
            {/* Grid Principal: Quiénes Somos + Misión & Visión */}
            <div className={styles.mainGrid}>
              {/* Columna Izquierda: ¿Quiénes Somos? */}
              <div className={styles.contentCard} id="quienes-somos">
                <div className={styles.contentCardHeader}>
                  <div className={styles.contentCardHeaderIcon}>
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </div>
                  <h2 className={styles.contentCardTitle}>
                    Nuestra Plataforma
                  </h2>
                </div>
                <p className={styles.cardText}>
                  Somos una plataforma digital que conecta y coordina toda la
                  cadena logística para envíos desde Estados Unidos hacia
                  Latinoamérica. Nuestro objetivo es simplificar el proceso de
                  envío, ofreciendo una solución tecnológica que integra a los
                  principales aliados de courier y transporte para brindar un
                  servicio confiable, eficiente y transparente.
                </p>
                <p className={styles.cardText}>
                  Coordinamos cada etapa del proceso logístico, desde la
                  recogida de tu paquete en la comodidad de tu hogar, oficina o
                  negocio en Estados Unidos hasta su entrega en el país de
                  destino en Latinoamérica. A través de nuestra red de aliados
                  estratégicos, garantizamos una operación ágil, segura y
                  respaldada por altos estándares de calidad.
                </p>
                <p className={styles.cardText}>
                  Nuestra plataforma centraliza la gestión de los envíos,
                  permitiendo a nuestros clientes acceder a una experiencia más
                  conectada, con seguimiento del paquete, información en tiempo
                  real y procesos simplificados que facilitan cada envío.
                </p>
                <p className={styles.cardText}>
                  Más que gestionar paquetes, conectamos personas, familias y
                  empresas entre Estados Unidos y Latinoamérica, haciendo que la
                  distancia no sea una barrera para enviar lo que más importa.
                </p>
              </div>

              {/* Columna Derecha: Misión y Visión */}
              <div className={styles.sideCards}>
                <div className={styles.infoCard} id="mision">
                  <div className={styles.infoCardHeader}>
                    <div className={styles.infoCardIcon}>
                      <FontAwesomeIcon icon={faBullseye} />
                    </div>
                    <h3 className={styles.infoCardTitle}>Nuestra Misión</h3>
                  </div>
                  <p className={styles.infoCardText}>
                    Facilitar los envíos desde Estados Unidos hacia
                    Latinoamérica mediante una plataforma tecnológica que
                    integre a los mejores aliados logísticos, ofreciendo un
                    servicio seguro, eficiente, transparente y orientado al
                    cliente.
                  </p>
                </div>

                <div className={styles.infoCard} id="vision">
                  <div className={styles.infoCardHeader}>
                    <div className={styles.infoCardIcon}>
                      <FontAwesomeIcon icon={faEye} />
                    </div>
                    <h3 className={styles.infoCardTitle}>Nuestra Visión</h3>
                  </div>
                  <p className={styles.infoCardText}>
                    Ser la plataforma digital líder en soluciones logísticas
                    para envíos desde Estados Unidos hacia Latinoamérica,
                    reconocida por la innovación, la excelencia operativa y la
                    confianza que generamos en nuestros clientes y aliados
                    comerciales.
                  </p>
                </div>
              </div>
            </div>

            {/* Fila Inferior: Valores */}
            <div className={styles.valuesSection} id="valores">
              <div className={styles.contentCardHeader}>
                <div className={styles.contentCardHeaderIcon}>
                  <FontAwesomeIcon icon={faShieldAlt} />
                </div>
                <h2 className={styles.contentCardTitle}>Nuestros Valores</h2>
              </div>

              <div className={styles.valuesGrid}>
                <div className={styles.valueCard}>
                  <FontAwesomeIcon
                    icon={faHandshake}
                    className={styles.valueCardIcon}
                  />
                  <h4 className={styles.valueCardTitle}>Compromiso</h4>
                  <p className={styles.valueCardText}>
                    Cumplimos con cada envío con responsabilidad y puntualidad.
                  </p>
                </div>

                <div className={styles.valueCard}>
                  <FontAwesomeIcon
                    icon={faLightbulb}
                    className={styles.valueCardIcon}
                  />
                  <h4 className={styles.valueCardTitle}>Innovación</h4>
                  <p className={styles.valueCardText}>
                    Aplicamos tecnología para optimizar la experiencia
                    logística.
                  </p>
                </div>

                <div className={styles.valueCard}>
                  <FontAwesomeIcon
                    icon={faEye}
                    className={styles.valueCardIcon}
                  />
                  <h4 className={styles.valueCardTitle}>Transparencia</h4>
                  <p className={styles.valueCardText}>
                    Mantenemos una comunicación clara y seguimiento continuo de
                    cada envío.
                  </p>
                </div>

                <div className={styles.valueCard}>
                  <FontAwesomeIcon
                    icon={faShieldAlt}
                    className={styles.valueCardIcon}
                  />
                  <h4 className={styles.valueCardTitle}>Confianza</h4>
                  <p className={styles.valueCardText}>
                    Trabajamos con aliados estratégicos que garantizan un
                    servicio de calidad.
                  </p>
                </div>

                <div className={styles.valueCard}>
                  <FontAwesomeIcon
                    icon={faBolt}
                    className={styles.valueCardIcon}
                  />
                  <h4 className={styles.valueCardTitle}>Eficiencia</h4>
                  <p className={styles.valueCardText}>
                    Integramos procesos para ofrecer soluciones ágiles y
                    confiables.
                  </p>
                </div>

                <div className={styles.valueCard}>
                  <FontAwesomeIcon
                    icon={faUserCheck}
                    className={styles.valueCardIcon}
                  />
                  <h4 className={styles.valueCardTitle}>
                    Orientación al cliente
                  </h4>
                  <p className={styles.valueCardText}>
                    Ponemos las necesidades de nuestros clientes en el centro de
                    cada decisión.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CompanyPage;
